import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-test-id"]
const _hoisted_2 = { class: "flex flex-row items-center gap-2" }
const _hoisted_3 = { class: "flex flex-row items-start grow gap-3" }
const _hoisted_4 = { class: "flex-col justify-center items-start gap-2.5 inline-flex" }
const _hoisted_5 = ["src", "alt"]

import { computed } from 'vue';
import { RichText } from '@sitecore-jss/sitecore-jss-vue';
import { IIProductStatus } from '@/interfaces';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductStatus',
  props: {
    message: {},
    productStatus: {},
    showButton: { type: Boolean },
    showPayNowButton: { type: Boolean },
    payButtonText: {},
    renewButtonText: {},
    renewalOfferFormLink: {},
    makeAPaymentLink: {},
    policyNumber: {},
    prn: {},
    dataTestId: {}
  },
  setup(__props: any) {

const props = __props;

const icon = computed(() => iconMap[props.productStatus]);
const backgroundColor = computed(() => backgroundColorMap[props.productStatus]);
const dataTestId = computed(() => props.dataTestId + dataTestIdMap[props.productStatus]);

const iconMap = {
  active: require('@/assets/icons/info-information.svg'),
  scheduled: require('@/assets/icons/icon-warning-wrapper.svg'),
  cancelled: require('@/assets/icons/icon-wrapper-error.svg'),
  paid: require('@/assets/icons/icon-wrapper-success.svg'),
};

const backgroundColorMap = {
  active: 'bg-racq-info-light-blue',
  scheduled: 'bg-racq-info-light-yellow',
  cancelled: 'bg-racq-info-light-red',
  paid: 'bg-racq-info-light-green',
};

const dataTestIdMap = {
  active: '_info_box',
  scheduled: '_info_box',
  cancelled: '_warning_box',
  paid: '_info_box',
};

const primaryBtnClick = () => {
  const url = props.showPayNowButton
    ? props.makeAPaymentLink?.value?.href + (props.prn ? '?prn=' + props.prn : '')
    : props.renewalOfferFormLink?.value?.href + '?policyId=' + props.policyNumber;
  window.open(url, '_blank');
};

return (_ctx: any,_cache: any) => {
  return (_ctx.message)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['w-full py-3 px-4 rounded', backgroundColor.value]),
        "data-test-id": dataTestId.value
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, [
              _createElementVNode("img", {
                class: "max-w-fit",
                src: icon.value,
                alt: `${_ctx.productStatus} icon`
              }, null, 8, _hoisted_5)
            ]),
            _createVNode(_unref(RichText), {
              "data-test-id": "infoText",
              class: "text-sm",
              field: { value: _ctx.message }
            }, null, 8, ["field"])
          ]),
          (_ctx.showButton)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "!min-w-24 btn btn-sm btn-primary",
                "data-test-id": "actionButton",
                onClick: primaryBtnClick
              }, _toDisplayString(_ctx.showPayNowButton ? _ctx.payButtonText : _ctx.renewButtonText), 1))
            : _createCommentVNode("", true)
        ])
      ], 10, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})